import { httpClient } from '..';
import { TProfile } from '../profileTypes';
import { TGetProfileResponse } from '../types';

export const fetchProfile = async (): Promise<TGetProfileResponse> => {
  const { data } = await httpClient.get('/profiles');
  return data;
};

export const updatePreferredLanguage = async (profile: TProfile): Promise<TGetProfileResponse> => {
  const { data } = await httpClient.put('/profiles', {
    responseType: 'json',
    data: profile,
  });

  return data;
}
